module.exports = __webpack_public_path__ + "img/logo-team.e9fe6e9a.svg";